import { Award, ChevronRight, TrendingUp, Users } from 'lucide-react';
import QRCode from 'qrcode';
import React, { useState, useEffect, useRef } from 'react';

const CampusRecruitmentPage: React.FC = () => {
  const [registrationUrl] = useState(
    'https://staging.app.fresherstoday.com/registration'
  );
  const qrCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (qrCanvasRef.current) {
      QRCode.toCanvas(qrCanvasRef.current, registrationUrl, {
        width: 180,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
    }
  }, [registrationUrl]);

  const handleRegisterClick = () => {
    //open the registration URL in a new tab
  };

  return (
    <div className='flex items-center justify-center bg-gray-100'>
      <div className='relative h-screen w-full max-w-3xl overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900'>
        <div className='absolute right-0 top-0 w-full opacity-30'>
          <img
            src='https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80'
            alt='Students'
            className='h-full w-full object-cover'
            style={{ mixBlendMode: 'overlay' }}
          />
        </div>
        {/* Decorative circles */}
        <div className='absolute right-0 top-0 h-96 w-96 rounded-full bg-blue-700 opacity-20 blur-3xl'></div>
        <div className='absolute left-0 top-40 h-64 w-64 rounded-full bg-blue-600 opacity-20 blur-3xl'></div>

        {/* Header */}
        <div className='flex items-start justify-between p-6'>
          <div className='flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white'>
            FT
          </div>
          <div className='text-right'>
            <h1 className='text-4xl font-bold tracking-wide text-white'>
              Freshers Today
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className=''>
          {/* Hero Section */}
          <div className='mb-6 text-center'>
            <h2 className='mb-2 text-3xl font-bold text-white'>INFOSYS</h2>
            <h3 className='mb-1 text-6xl font-black leading-tight text-white'>
              CAMPUS
            </h3>
            <h3 className='mb-3 text-6xl font-black leading-tight text-white'>
              RECRUITMENT
            </h3>
            <p className='pb-16 text-3xl font-bold text-white'>
              Mock Assessment (2026 Batch)
            </p>
          </div>

          {/* Description Box */}
          <div className='absolute right-[13%] top-[37%] mx-auto mb-6 w-full max-w-xl rounded-lg bg-[#00477D] p-4'>
            <p className='text-center text-sm leading-relaxed text-white'>
              In Association with{' '}
              <span className='font-bold'>APTPO Consortium</span>
              <br />
              <span className='font-bold'>Freshers Today</span> presents a Mock
              Assessment designed with the exact <br />
              <span className='font-bold'>Infosys recruitment pattern</span> for
              all eligible <span className='font-bold'>2026 batch</span>{' '}
              students.
            </p>
          </div>

          <div className='bg-white'>
            {/* Why Join Section */}
            <div className='mb-6 pt-16'>
              <h4 className='my-4 text-center text-2xl font-bold text-[#00477D]'>
                WHY JOIN?
              </h4>

              <div className='mx-auto grid max-w-4xl grid-cols-3 gap-4'>
                <div className='rounded-lg bg-white p-4 text-center'>
                  <div className='mb-2 flex justify-center'>
                    <Award
                      className='h-12 w-12 text-blue-900'
                      strokeWidth={1.5}
                    />
                  </div>
                  <h5 className='text-sm font-bold leading-tight text-blue-900'>
                    Practice with the
                    <br />
                    real test pattern
                  </h5>
                </div>

                <div className='rounded-lg bg-white p-4 text-center'>
                  <div className='mb-2 flex justify-center'>
                    <TrendingUp
                      className='h-12 w-12 text-blue-900'
                      strokeWidth={1.5}
                    />
                  </div>
                  <h5 className='text-sm font-bold leading-tight text-blue-900'>
                    Boost confidence
                    <br />
                    before the actual drive
                  </h5>
                </div>

                <div className='rounded-lg bg-white p-4 text-center'>
                  <div className='mb-2 flex justify-center'>
                    <Users
                      className='h-12 w-12 text-blue-900'
                      strokeWidth={1.5}
                    />
                  </div>
                  <h5 className='text-sm font-bold leading-tight text-blue-900'>
                    Experience the true
                    <br />
                    exam environment
                  </h5>
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className='grid grid-cols-2 gap-8 px-14'>
              {/* QR Code Section */}
              <div className='text-left'>
                <h5 className='mb-3 font-bold text-black'>
                  Scan Here to Register Now
                </h5>
                <div className='inline-block rounded-lg bg-white p-3'>
                  <canvas ref={qrCanvasRef} />
                </div>
              </div>

              {/* Call to Action Section */}
              <div className='flex flex-col'>
                <div className='text-center'>
                  <p className='text-sm text-black'>With Best Regards,</p>
                  <p className='mb-4 text-lg font-bold text-black'>
                    APTPO Consortium | Freshers Today Team
                  </p>
                </div>

                <div className='mt-[70px] rounded-lg bg-[#00477D] px-6 py-3 text-center text-white'>
                  <p className='text-xl font-bold leading-tight'>
                    LIMITED SLOTS
                  </p>
                  <p className='text-lg font-bold leading-tight'>
                    DON&apos;T MISS OUT!
                  </p>
                </div>
              </div>
            </div>

            {/* Footer Bar */}
            <div className='h-18 mx-auto mt-6 flex w-[85%] items-center justify-center bg-[#00477D] text-center'>
              <button
                onClick={handleRegisterClick}
                className='mx-auto flex items-center rounded-full px-10 py-4 text-xl font-bold text-white transition-colors duration-300 md:mx-0'
              >
                Register Now
                <ChevronRight className='ml-2 h-6 w-6' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampusRecruitmentPage;
